export default [
  {
    desk_label: 'scrivania',
    room_label: 'sala',
    parking_label: 'parcheggio',
    analytics_label: 'Analytics',
    reception_label: 'Reception',
    desk_title: 'Seleziona la scrivania adatta a te',
    room_title: 'Seleziona la sala adatta a te',
    date_label: 'Data',
    dateStartWeek_label: 'Data inizio settimana',
    dateStartMonth_label: 'Data inizio mese',
    dateEndWeek_label: 'Data fine settimana',
    dateEndMonth_label: 'Data fine mese',
    time_label: 'Ora',
    dateStart_label: 'Data inizio',
    dateStartViewMode_label: 'Data',
    dateEnd_label: 'Data fine',
    office_label: 'Seleziona sede',
    floor_label: 'Seleziona piano',
    area_label: 'Seleziona area',
    availability_label: 'Solo disponibili',
    capacity_label: 'Capienza',
    equipment_label: 'Attrezzatura',
    deskNoItems_message: 'Nessuna scrivania trovata.',
    roomNoItems_message: 'Nessuna sala trovata.',
    deskNoAvailableItems_message: 'Nessuna scrivania disponibile.',
    roomNoAvailableItems_message: 'Nessuna sala disponibile.',
    ethernet_label: 'Ethernet',
    videoconference_label: 'Videoconferenza',
    microphone_label: 'Microfono',
    camera_label: 'Telecamera',
    speaker_label: 'Casse',
    monitor_label: 'Schermo',
    standardWorkspace_label: 'Postazione standard',
    graphicsWorkspace_label: 'Postazione grafica',
    lamp_label: 'Lampada',
    designatedWorkspace_label: 'Postazione assegnata',
    refresh_label: 'Aggiorna',
    confirm_label: 'Conferma',
    cancel_label: 'Annulla',
    book_label: 'Prenota',
    show_label: 'Visualizza',
    unbook_label: 'Annula prenotazione ',
    viewMode_label:
      "La griglia è in modalità di visualizzazione, per prenotare una sala è necessario aprire il plugin all'interno di Outlook.",
    from_label: ' dalle ',
    to_label: ' alle ',
    booked_label: ' prenotato',
    unbooked_label: ' prenotazione annullata',
    generic_error: 'ops! si è verificato un problema.',
    name_label: 'Nome',
    company_label: 'Azienda',
    service_location_label: 'Ubicazione di servizio',
    department_label: 'Dipartimento',
    filter_label: 'Filtri di ricerca',
    status_label: 'Stato',
    alreadyBooked_label: ' non disponibile',
    overlap_label: 'hai già prenotato',
    pageNotFound_error: 'Pagina non trovata',
    firstname_label: 'Nome',
    lastname_label: 'Cognome',
    email_label: 'Email',
    realtime_label: 'Real time',
    daily_label: 'Giornaliero',
    weekly_label: 'Settimanale',
    monthly_label: 'Mensile',

    timeManagement_label: 'Time Management',
    officesOccupations_label: 'Occupazione sedi',
    roomOccupations_label: 'Occupazione sale',
    parkingOccupations_label: 'Occupazione parcheggi',
    timeManagementADM_label: 'ADM Time Management',

    room_list_label: 'Lista delle sale',
    room_top_users_label: 'Top utenti',
    average_minutes_booked_label: 'Minuti prenotati in media nel periodo',
    minutes_booked_by_range_label: 'Minuti prenotati - Medie per fascia oraria',
    minutes_booked_by_date_label: 'Minuti prenotati - Medie per giorno',
    most_booked_rooms_label: 'Sale più prenotate',

    timeManagement_label: 'Time Management',
    meetingList_label: 'Lista dei meeting',
    externalCustomerList_label: 'Lista dei clienti esterni',
    smartReceptionAccesses_label: 'Registrazioni Smart Reception',
    accessList_label: 'Accessi Smart Gate',
    passHandler_label: 'Gestore pass',
    officesOccupations_label: 'Occupazione sedi',
    timeManagementADM_label: 'Time Management Admin',

    academy_label: 'Academy',
    courseList_label: 'Calendario dei corsi',
    courseCalendar_label: 'Corsi prenotati',
    employeeRecap_label: 'Riepilogo dipendenti',
    academyFAQ_label: 'Domande frequenti (FAQ)',

    tutorial_label: 'Tutorial',
    searchUser_label: 'Cerca utente',
    referent_label: 'Referente',
    employment_statistics_locations_label: 'Statistiche occupazione media sedi',
    booking_cancellations_label: 'Cancellazioni prenotazioni',
    check_in_out_label: 'Check in/out',
    export_label: 'Esporta',
    most_booked_desks_label: 'Top desk più prenotati',
    less_booked_desks_label: 'Desk meno prenotati',
    users_multiple_bookings_label: 'Top utenti con più prenotazioni',
    users_fewer_bookings_label: 'Utenti con meno prenotazioni',
    heatmap_bookings_label: 'Heatmap prenotazioni',
    histogram_desks_label: 'Prenotazioni desk',
    bookings_singular_label: 'prenotazione',
    bookings_plural_label: 'prenotazioni',
    capitalized_booked_label: 'Prenotati',
    free_label: 'Liberi',
    service_location_label: 'Ubicazione servizio',
    statistics_working_status_label: 'Statistiche stati lavorativi',
    all_label: 'Tutti',
    notDefined_label: 'Non definito',
    unknown_label: 'Sconosciuti',
    statistics_office_ws_label: 'Stato lavorativo per sede',
    statistics_ws_heatmap_label: 'Heatmap stati lavorativi',
    employment_statistics_locations_user_label: 'Statistiche occupazione sedi per utente',
    unknown_working_state: 'Unknown',
    select_user_placeholder: 'Seleziona un utente',
    abbreviation_department_label: 'Dip:',
    tot_5_users_month_working_status_label: 'Top utenti del mese per stato lavorativo',
    others_label: 'Altri',
    total_label: 'Totale',
    working_state_label: 'Stato lavorativo',
    totals_label: 'Totali',
    close_label: 'Chiudi',
    notFillFields_label: 'Compilare tutti i campi di ricerca richiesti',
    state_meeting_label: 'Stato meetings',
    organizer_name_label: 'Nome / Email organizzatore',
    name_participant_label: 'Nome / Email partecipante',
    input_placeholder: 'min. 3 caratteri',
    show_detail: 'Mostra dettagli',

    //Parking Stats labels
    parking_stats_occupancy_label: 'Occupazione parcheggi',
    parking_stats_usage_label: 'Prenotazioni cancellate parcheggi',
    parking_stats_histogram_label: 'Medie prenotazioni per giorno',
    parking_stats_heatmap_label: 'Prenotazioni per giorno',

    average_label: 'Media',

    id_customer_label: 'ID',
    portal_dismissed: 'Vai alla nuova Web App',
    portal_continue: "Continua con l' attuale",
  },
];
